import { Shadow, TableItem, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { ResponsesBalanceResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { pensionDetailsStatememntsWidthCols } from '../../../../../../constants';
import { messageError, validateAndFormatValue } from '../../../../Table/constants';

interface DetailsStatementsItemProps {
  item: ResponsesBalanceResponse;
  isLastItem: boolean;
}

export const DetailsStatementsItem: React.FC<DetailsStatementsItemProps> = ({
  item,
  isLastItem,
}) => {
  const balanceDate = validateAndFormatValue(item?.balanceDate, 'date');
  const balance = validateAndFormatValue(item?.balance, 'money');
  const quantityQuota =
    item?.quantityQuota || item?.quantityQuota === 0 ? item.quantityQuota : messageError;
  const quotaValue = item?.quotaValue || item?.quotaValue === 0 ? item.quotaValue : messageError;
  const launch = isLastItem ? 'SALDO FINAL' : 'SALDO INICIAL';
  const grossValue = messageError;
  const irValue = messageError;
  const netValue = messageError;

  const isMobile = useBreakpointValue({ base: true, sm: false });

  if (isMobile) {
    return (
      <Box marginBottom={Spacing['inset.nano']}>
        <Shadow level={3} borderRadius={BoxRadius.sm}>
          <VStack
            space={Spacing['inset.nano']}
            borderRadius={BoxRadius.sm}
            p={Spacing['inline.xxxs']}>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Data
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {balanceDate}
              </Text>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Lançamento
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {launch}
              </Text>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Saldo(R$)
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {balance}
              </Text>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Valor da cota
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {quotaValue}
              </Text>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Qtd. de cotas
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {quantityQuota}
              </Text>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Valor bruto
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {grossValue}
              </Text>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                IR
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {irValue}
              </Text>
            </HStack>
            <HStack alignItems={'center'} justifyContent={'space-between'}>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.black'}
                variant={'regular'}>
                Valor líquido
              </Text>
              <Text
                fontSize={Typography['fontsize.md']}
                color={'neutral.darkest'}
                variant={'regular'}>
                {netValue}
              </Text>
            </HStack>
          </VStack>
        </Shadow>
      </Box>
    );
  }

  return (
    <HStack
      marginBottom={Spacing['inset.nano']}
      alignItems="center"
      justifyContent="space-between"
      py={Spacing['inline.xxxs']}>
      <TableItem
        testId="statement-pension-statements-item-date"
        width={pensionDetailsStatememntsWidthCols.date.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {balanceDate}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-pension-statements-item-launch"
        width={pensionDetailsStatememntsWidthCols.launch.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {launch}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-pension-statements-item-balance"
        width={pensionDetailsStatememntsWidthCols.balance.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {balance}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-pension-statements-item-quotaValue"
        width={pensionDetailsStatememntsWidthCols.quotaValue.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {quotaValue}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-pension-statements-item-quotasAmount"
        width={pensionDetailsStatememntsWidthCols.quotasAmount.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {quantityQuota}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-pension-statements-item-va.grossValue"
        width={pensionDetailsStatememntsWidthCols.grossValue.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {grossValue}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-pension-statements-item-ir"
        width={pensionDetailsStatememntsWidthCols.ir.desktop}>
        <Text fontSize={Typography['fontsize.xs']} noOfLines={1} variant={'regular'}>
          {irValue}
        </Text>
      </TableItem>
      <TableItem
        testId="statement-pension-statements-item-pensionNetValue"
        width={pensionDetailsStatememntsWidthCols.pensionNetValue.desktop}>
        <Box w={'full'}>
          <Text
            fontSize={Typography['fontsize.xs']}
            noOfLines={1}
            variant={'regular'}
            textAlign={'end'}>
            {netValue}
          </Text>
        </Box>
      </TableItem>
    </HStack>
  );
};
